var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#801950;stroke:#801950;stroke-miterlimit:10;stroke-width:25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M203.14,406.29c11.57-4.34,30.33-9.76,53.86-9.51,21.95,.23,39.53,5.29,50.75,9.51,1.75,.42,22.06,4.86,37.29-9.51,12.31-11.62,16.14-30.68,9.32-47.55-8.29-13.85-18.21-28.84-30.04-44.38-12.36-16.24-24.69-30.28-36.25-42.27-3.07-2.85-13.32-11.64-29-12.68-19.55-1.3-32.77,10.43-35.22,12.68-13.1,14.02-26.73,29.83-40.4,47.55-10.35,13.41-19.64,26.52-27.97,39.1-8.26,15.86-5.64,35.21,6.21,47.55,10.55,10.99,26.76,14.71,41.43,9.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 402.89,
    cy: 256.58,
    rx: 48.03,
    ry: 36.14,
    transform: "translate(38.92 565.91) rotate(-72.85)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 319.86,
    cy: 156.42,
    rx: 52.5,
    ry: 42.45,
    transform: "translate(130.05 457.66) rotate(-83.84)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 109.11,
    cy: 255.96,
    rx: 36.14,
    ry: 48.03,
    transform: "translate(-70.62 43.55) rotate(-17.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 192.14,
    cy: 155.8,
    rx: 42.45,
    ry: 52.5,
    transform: "translate(-15.6 21.5) rotate(-6.16)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.470cef3229c7ad1a7c044316eb24513c.svg";
export { ForwardRef as ReactComponent };